import React, { useCallback, useState } from 'react';

import { useSnackbar } from 'notistack';

import InviteCreator from '../../components/creators/InviteCreator';
import ValidationException from '../../exceptions/ValidationException';
import User from '../../models/User';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [validationErrors, setValidationErrors] = useState(null);
  const [defaultData, setDefaultData] = useState(new User());
  const [resetData, setResetData] = useState(false);
  const blocRef = useBlocRef('creatorsBloc');
  const { enqueueSnackbar } = useSnackbar();

  const onInviteCreator = async ({ name, phoneNumber, email, isTrainee }) => {
    try {
      setResetData(false);
      await blocRef.current.inviteCreator(name, phoneNumber, email, isTrainee);
      setDefaultData(new User());
      setValidationErrors(null);
      setResetData(true);
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };

  const handleSetExternalError = useCallback((fieldName, value) => {
    setValidationErrors((errors) => ({ ...(errors || {}), [fieldName]: value }));
  }, []);

  return (
    <InviteCreator
      resetData={resetData}
      onInviteCreator={onInviteCreator}
      validationErrors={validationErrors}
      defaultData={defaultData}
      isSubmitting$={blocRef.current.isSubmitting$}
      onSetExternalError={handleSetExternalError}
    />
  );
};
